import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import axioPath from '../../../../../api/axioPath';
import { showAppLoader, hideAppLoader } from '../../../../../redux/actions/app';
import Spinner from '../../../../components/Spinner';
import { SelectWrapper } from '../DashBoard/dashBoardStyled'
import SearchTypeahead from './SearchTypeahead';
import { Container, PanelWrapper, InnerDiv, DateRangeInnerDiv, SearchSection, TableWrapper, DateWrapper, MultiSelectFieldWrapper } from './reportStyled'
import AlertModal from 'web/components/AlertModal';
import MultiSelect from "web/components/MultiSelect";
import { selectStyle, buttonStyle, monthList, monthListWithAll, subscriptionList, orderStatus, pickupOrderStatus, claimLists, commissionTypeArr } from './Constants'

//radio
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Heading } from 'web/pages/private/Admin/adminStyled'
import moment from 'moment';
import DatePicker from 'web/components/DatePicker';

import { getAllStatesOfCountry, getAllCitiesOfState } from "helpers";

function Reports() {
  let history = useHistory();
  let location = useLocation();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const toggleModal = () => setModal(!modal);
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const [value, setValue] = useState(0);
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const thisYear = (new Date()).getFullYear();
  const thisMonth = (new Date()).getMonth();
  const [subReportData, setSubReportData] = useState([])
  const [subYears, setSubYears] = useState([]);
  let toDate = new Date();
  toDate.setMonth(new Date().getMonth() + 1)

  let fromDate = new Date();
  fromDate.setMonth(new Date().getMonth() - 1)

  const [subscriptionReportState, setSubscriptionReportState] = useState({
    state: '',
    city: '',
    userType: 'all',
    month: '',
    year: thisYear,
    subscription: 'All Subscriptions'
  })

  let toDatePurchaseReport = new Date();
  let fromDatePurchaseReport = new Date();
  fromDatePurchaseReport.setMonth(fromDatePurchaseReport.getMonth() - 1)
  const [startPurchaseDateValue, setStartPurchaseDateValue] = useState(moment(fromDatePurchaseReport).format("MM/DD/YYYY"))
  const [endPurchaseDateValue, setEndPurchaseDateValue] = useState(moment(toDatePurchaseReport).format("MM/DD/YYYY"))
  const [purchaseState, setPurchaseState] = useState({
    purchase: 'both',
    userType: 'all',
    payment: 'All',
    fromDate: moment(fromDatePurchaseReport).format("YYYY-MM-DD"),
    toDate: moment(toDatePurchaseReport).format("YYYY-MM-DD"),
    state: '',
    city: '',
    companyName: ''
  })

  //set other reports date default for Posts, Claim, Commision
  let toDateOtherReports = new Date();
  let fromDateOtherReports = new Date();
  fromDateOtherReports.setMonth(fromDateOtherReports.getMonth() - 1)
  toDateOtherReports.setMonth(toDateOtherReports.getMonth() + 1)
  const [startOtherReportsDateValue, setStartOtherReportsDateValue] = useState(moment(fromDateOtherReports).format("MM/DD/YYYY"))
  const [endOtherReportsDateValue, setEndOtherReportsValue] = useState(moment(toDateOtherReports).format("MM/DD/YYYY"))
  const [orderState, setOrderState] = useState({
    state: '',
    city: '',
    userType: 'both',
    month: '',
    year: thisYear,
    status: 'All',
    companyName: ''
  })
  const [pickupOrderState, setPickupOrderState] = useState({
    state: '',
    city: '',
    fromDate: moment().subtract(2, 'months').format("MM/DD/YYYY"),
    toDate: moment().add(1, 'month').format("MM/DD/YYYY"),
    status: [{ value: 'ALL', label: 'All' }],
    companyName: ''
  })
  const [claimState, setClaimState] = useState({
    claimType: 'All',
    state: '',
    city: '',
    fromDate: moment(fromDateOtherReports).format("YYYY-MM-DD"),
    toDate: moment(toDateOtherReports).format("YYYY-MM-DD"),
    companyName: ''
  })
  const [loadInventoryState, setLoadInventoryState] = useState({
    postType: 'postLoad',
    state: '',
    city: '',
    fromDate: moment(fromDateOtherReports).format("YYYY-MM-DD"),
    toDate: moment(toDateOtherReports).format("YYYY-MM-DD"),
    companyName: ''
  })
  const [referralReportState, setReferralReportState] = useState({
    month: monthList[thisMonth].value,
    year: thisYear

  })

  const [commissionState, setCommissionState] = useState({
    commissionType: "BOTH",
    byLocation: "ALL",
    contactName: "ALL",
    fromDate: moment(fromDateOtherReports).format("YYYY-MM-DD"),
    toDate: moment(toDateOtherReports).format("YYYY-MM-DD"),
    month: monthList[thisMonth].value,
    year: thisYear
  })

  const [radioValue, setRadioValue] = useState('AVAILABLE');
  const handleRadioChange = (event) => setRadioValue(event.target.value)

  const states = getAllStatesOfCountry('US').map((state) => ({
    value: state.name,
    label: `${state.isoCode}-${state.name}`,
    isoCode: state.isoCode
  }));
  const currentSubReportState
        = states.find((c) => c.value === subscriptionReportState.state)?.isoCode || '';
  const currentOrderState =
        states.find((c) => c.value === (value === 2 ? orderState.state : pickupOrderState.state))?.isoCode || '';
  const currentClaimState =
        states.find((c) => c.value === claimState.state)?.isoCode || '';
  const currentPurchaseState =
        states.find((c) => c.value === purchaseState.state)?.isoCode || '';
  const currentLoadInvState =
        states.find((c) => c.value === loadInventoryState.state)?.isoCode || '';

  const subReportCities = getAllCitiesOfState(currentSubReportState, 'US')
    ?.map((city) => ({ value: city, label: city })) ?? [];
  const purchaseCities = getAllCitiesOfState(currentPurchaseState, 'US')
    ?.map((city) => ({ value: city, label: city })) ?? [];
  const orderCities = getAllCitiesOfState(currentOrderState, 'US')
    ?.map((city) => ({ value: city, label: city })) ?? [];
  const claimCities = getAllCitiesOfState(currentClaimState, 'US')
    ?.map((city) => ({ value: city, label: city })) ?? [];
  const loadInvCities = getAllCitiesOfState(currentLoadInvState, 'US')
    ?.map((city) => ({ value: city, label: city })) ?? [];

  const handleSubReportStateChange = (e) => {
    const { id, value } = e.target
    setSubscriptionReportState(prevState => ({
      ...prevState,
      [id]: value
    }))
    if (id === 'state' && value === '') {
      setSubscriptionReportState(prevState => ({
        ...prevState,
        city: value
      }))
    }
  }
  const handlePurchaseStateChange = (e) => {
    const { id, value } = e.target
    setPurchaseState(prevState => ({
      ...prevState,
      [id]: value
    }))
    if (id === 'state' && value === '') {
      setPurchaseState(prevState => ({
        ...prevState,
        city: value
      }))
    }
  }
  const handleOrderStateChange = (e) => {
    const { id, value } = e.target
    setOrderState(prevState => ({
      ...prevState,
      [id]: value
    }))
    if (id === 'state' && value === '') {
      setOrderState(prevState => ({
        ...prevState,
        city: value
      }))
    }
  }
  const handlePickupOrderStateChange = (e) => {
    const { id, value } = e.target
    setPickupOrderState(prevState => ({
      ...prevState,
      [id]: value
    }))
    if (id === 'state' && value === '') {
      setPickupOrderState(prevState => ({
        ...prevState,
        city: value
      }))
    }
  }
  const handleClaimStateChange = (e) => {
    const { id, value } = e.target
    setClaimState(prevState => ({
      ...prevState,
      [id]: value
    }))
    if (id === 'state' && value === '') {
      setClaimState(prevState => ({
        ...prevState,
        city: value
      }))
    }
  }
  const handlePostStateChange = (e) => {
    const { id, value } = e.target
    setLoadInventoryState(prevState => ({
      ...prevState,
      [id]: value
    }))
    if (id === 'state' && value === '') {
      setLoadInventoryState(prevState => ({
        ...prevState,
        city: value
      }))
    }
  }
  const handleReferralStateChange = (e) => {
    const { id, value } = e.target
    setReferralReportState(prevState => ({
      ...prevState,
      [id]: value
    }))
  }
  const [dateSelect, setDateSelect] = useState(false);
  const handleCommissionTypeStateChange = (e) => {
    const { id, value } = e.target
    if (id === "fromDate" || id === "toDate ") {
      setDateSelect(true)
    }
    setCommissionState(prevState => ({
      ...prevState,
      [id]: value
    }))
  }
  //change tab index
  const handleChange = (event, newValue) => {
    setValue(newValue);
    //set purchase date default
    let toDatePurchaseReport = new Date();
    let fromDatePurchaseReport = new Date();
    fromDatePurchaseReport.setMonth(fromDatePurchaseReport.getMonth() - 1)
    setPurchaseState((prevState) => ({
      ...prevState,
      ["fromDate"]: moment(fromDatePurchaseReport).format("YYYY-MM-DD"),
      ["toDate"]: moment(toDatePurchaseReport).format("YYYY-MM-DD"),
    }));
    setStartPurchaseDateValue(moment(fromDatePurchaseReport).format("MM/DD/YYYY"))
    setEndPurchaseDateValue(moment(toDatePurchaseReport).format("MM/DD/YYYY"))
    //set other reports date default (Posts, Claim, Commision)
    let toDateOtherReports = new Date();
    let fromDateOtherReports = new Date();
    fromDateOtherReports.setMonth(fromDateOtherReports.getMonth() - 1)
    toDateOtherReports.setMonth(toDateOtherReports.getMonth() + 1)

    setClaimState((prevState) => ({
      ...prevState,
      ["fromDate"]: moment(fromDateOtherReports).format("YYYY-MM-DD"),
      ["toDate"]: moment(toDateOtherReports).format("YYYY-MM-DD"),
    }));
    setLoadInventoryState((prevState) => ({
      ...prevState,
      ["fromDate"]: moment(fromDateOtherReports).format("YYYY-MM-DD"),
      ["toDate"]: moment(toDateOtherReports).format("YYYY-MM-DD"),
    }));
    setCommissionState((prevState) => ({
      ...prevState,
      ["fromDate"]: moment(fromDateOtherReports).format("YYYY-MM-DD"),
      ["toDate"]: moment(toDateOtherReports).format("YYYY-MM-DD"),
    }));
    setStartOtherReportsDateValue(moment(fromDateOtherReports).format("MM/DD/YYYY"))
    setEndOtherReportsValue(moment(toDateOtherReports).format("MM/DD/YYYY"))
  };

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    let tempSubYears = []
    if (location.state !== null && location.state !== undefined) {
      if (location.state.page === 'purchase') setValue(1);
      if (location.state.page === 'order') setValue(2);
      if (location.state.page === 'pickupOrder') setValue(3);
      if (location.state.page === 'claim') setValue(4);
      if (location.state.page === 'post') setValue(5);
      if (location.state.page === 'referral') setValue(6);
      if (location.state.page === 'commissionType') setValue(7);
    }
    for (let year = thisYear; year >= thisYear - 10; year--) {
      tempSubYears.push(year);
    }
    setSubYears(tempSubYears)
    commissionLocations()
  }, []);

  const [commissionLocationType, setCommissionLocationType] = useState('AVAILABLE');

  const [commissionLocationResonse, setCommissionLocationResonse] = useState();

  const commissionLocations = () => {
    dispatch(showAppLoader());
    const token = localStorage.getItem("token")
    let url = `user/commission/get_commission_location`
    axioPath.get(url, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      if (response?.data?.status === 'SUCCESS') {
        if (response?.data?.payload) {
          let arr = [{ label: "All", value: "ALL" }]
          if (response?.data?.payload.length !== 0) {
            for (let i = 0; i < response?.data?.payload.length; i++) {
              let obj = {
                label: response?.data?.payload[i].locationName,
                value: response?.data?.payload[i].locationId
              }
              arr.push(obj)
              if (response?.data?.payload.length - 1 === i) {
                setCommissionLocationResonse(arr)
              }
            }
            setCommissionLocationType(response?.data?.payload)
          } else {
            setCommissionLocationResonse(arr)
          }
        } else {
          let arr = [{ label: "All", value: "ALL" }]
          setCommissionLocationResonse(arr)
        }
        contactNameList()
      } else {
        let arr = [{ label: "All", value: "ALL" }]
        setCommissionLocationResonse(arr)
        if (response.data.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.data.message)
          setModal(!modal)
        }
      }
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response?.status === 401) {
        history.push('./sign-in')
        window.location.reload(false)
      } else {
        setModalContent(ex.response?.data?.message || ex.message)
        setModal(!modal)
      }
    });
  };

  const [contactResonse, setContactResonse] = useState();
  const contactNameList = () => {
    dispatch(showAppLoader());
    const token = localStorage.getItem("token");
    let url = `user/commission/get_commission_agent`
    axioPath.get(url, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      if (response?.data?.status === 'SUCCESS') {
        if (response?.data?.payload) {
          let arr = [{ label: "All", value: "ALL" }]
          if (response?.data?.payload.length !== 0) {
            for (let i = 0; i < response?.data?.payload.length; i++) {
              let obj = {
                label: response?.data?.payload[i].userName,
                value: response?.data?.payload[i].userId
              }
              arr.push(obj)

              if (response?.data?.payload.length - 1 === i) {
                setContactResonse(arr)
              }
            }
          } else {
            setContactResonse(arr)
          }

        } else {
          let arr = [{ label: "All", value: "ALL" }]
          setContactResonse(arr)
        }
      } else {
        let arr = [{ label: "All", value: "ALL" }]
        setContactResonse(arr)
        if (response.data.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.data.message)
          setModal(!modal)
        }
      }
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response?.status === 401) {
        history.push('./sign-in')
        window.location.reload(false)
      } else {
        setModalContent(ex.response?.data?.message || ex.message)
        setModal(!modal)
      }
    });
  };

  const fetchSubReportAPI = () => {
    dispatch(showAppLoader());
    const token = localStorage.getItem("token")
    axioPath.get('/user/subscription/info', {
      headers: {
        Authorization: token,
        month: subscriptionReportState.month,
        year: subscriptionReportState.year,
        userType: subscriptionReportState.userType,
        city: subscriptionReportState.city,
        state: subscriptionReportState.state
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      if (response.data.status === 'SUCCESS') {
        if (response.data.payload) {
          let userSubList = response.data.payload
          let tempData1 = Object.values(userSubList)
          setSubReportData(tempData1)
          history.push({
            pathname: '/subscriptionReports',
            state: { data: tempData1, subscription: subscriptionReportState.subscription }
          })
        }
      } else {
        if (response.data.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.data.message)
          setModal(!modal)
        }
      }
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response?.status === 401) {
        history.push('./sign-in')
        window.location.reload(false)
      } else {
        setModalContent(ex.response?.data?.message || ex.message)
        setModal(!modal)
      }
    });
  };

  const fetchPurchaseReportApi = () => {
    if (!purchaseState.toDate || !purchaseState.fromDate) {
      setModalContent("Please enter the correct Date Range.");
      setModal(!modal)
      return
    }
    dispatch(showAppLoader());
    const token = localStorage.getItem("token")
    let headerData = {
      Authorization: token,
      purchase: purchaseState.purchase === 'scription' ? 'subscription' : purchaseState.purchase,
      dateRange: purchaseState.fromDate,
      dateTo: purchaseState.toDate,
      userType: purchaseState.userType,
      state: '',
      city: ''
    }
    if (purchaseState.state !== '') {
      headerData.state = purchaseState.state
    }
    if (purchaseState.city !== '') {
      headerData.city = purchaseState.city
    }
    axioPath.get('/user/admin/subscription/info', {
      headers: headerData,
    }).then((response) => {
      dispatch(hideAppLoader());
      if (response.data.status === 'SUCCESS') {
        if (response.data.payload) {
          let userSubList = response.data.payload?.body?.payload
          setSubReportData(userSubList)
          history.push({
            pathname: '/purchaseReports',
            state: { data: userSubList, purchase: purchaseState.purchase, payment: purchaseState.payment, filters: purchaseState }
          })
        }
      } else {
        if (response.data.message === "Unauthorized (Invalid token)" || response.data.message === 'Full authentication is required to access this resource') {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.data.message)
          setModal(!modal)
        }
      }
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response?.status === 401) {
        history.push('./sign-in')
        window.location.reload(false)
      } else {
        setModalContent(ex.response?.data?.message || ex.message)
        setModal(!modal)
      }
    });
  };

  const fetchOrderReportApi = () => {
    history.push({
      pathname: '/orderReports',
      state: { data: [], status: orderState.status, filter: orderState }
    })
  };

  const fetchPickupOrderReportApi = () => {
    let fromDateVal = moment(pickupOrderState?.fromDate, 'MM/DD/YYYY')
    let toDateVal = moment(pickupOrderState?.toDate, 'MM/DD/YYYY')
    if (!fromDateVal.isValid() || !toDateVal.isValid() || toDateVal.isBefore(fromDateVal)) {
      setModalContent('Please select a valid date.')
      setModal(!modal)
      return
    }
    history.push({
      pathname: '/pickupOrderReports',
      state: { data: [], status: pickupOrderState.status, filter: pickupOrderState }
    })
  };

  const fetchClaimReportApi = () => {
    if (!claimState.toDate || !claimState.fromDate) {
      setModalContent("Please enter the correct Date Range.");
      setModal(!modal)
      return
    }
    dispatch(showAppLoader());
    const token = localStorage.getItem("token")
    let url = `order/claim-report?fromDate=${claimState.fromDate}&toDate=${claimState.toDate}&claimType=${claimState.claimType}&companyName=${claimState.companyName}`
    if (claimState.state != '') url = `${url}&state=${claimState.state}`
    if (claimState.city != '') url = `${url}&city=${claimState.city}`
    axioPath.get(url, {
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      if (response.data.status === 'SUCCESS') {
        if (response.data.payload) {
          let userSubList = response.data.payload
          let tempData1 = Object.values(userSubList)
          history.push({
            pathname: '/claimReports',
            state: { data: tempData1, claimType: claimState.claimType }
          })
        }
      } else {
        if (response.data.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.data.message)
          setModal(!modal)
        }
      }
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response?.status === 401) {
        history.push('./sign-in')
        window.location.reload(false)
      } else {
        setModalContent(ex.response?.data?.message || ex.message)
        setModal(!modal)
      }
    });
  };

  const fetchLoadInventoryReportApi = () => {
    if (!loadInventoryState.toDate || !loadInventoryState.fromDate) {
      setModalContent("Please enter the correct Date Range.");
      setModal(!modal)
      return
    }
    dispatch(showAppLoader());
    const token = localStorage.getItem("token")
    let url = `rfp/${loadInventoryState.postType}/report/${loadInventoryState.postType}/all?query=${radioValue}&fromDate=${loadInventoryState.fromDate}&toDate=${loadInventoryState.toDate}&state=${loadInventoryState.state}&city=${loadInventoryState.city}&companyName=${loadInventoryState.companyName}`
    axioPath.get(url, {
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      if (response.data.status === 'SUCCESS') {
        if (response.data.payload) {
          let userSubList = response.data.payload
          let tempData1 = Object.values(userSubList)
          history.push({
            pathname: '/loadInventoryReports',
            state: { data: tempData1, filters: loadInventoryState }
          })
        }
      } else {
        if (response.data.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.data.message)
          setModal(!modal)
        }
      }
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response?.status === 401) {
        history.push('./sign-in')
        window.location.reload(false)
      } else {
        setModalContent(ex.response?.data?.message || ex.message)
        setModal(!modal)
      }
    });
  };

  const fetchReferralsReportApi = () => {
    dispatch(showAppLoader());
    const token = localStorage.getItem("token")
    let url = 'user/referral/info'
    axioPath.get(url, {
      headers: {
        Authorization: token,
        month: referralReportState.month,
        year: referralReportState.year,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      if (response.data.status === 'SUCCESS') {
        if (response.data.payload) {
          let userSubList = response.data.payload
          if (userSubList.length === 0) {
            setModalContent("No records found")
            setModal(!modal)
          } else {
            history.push({
              pathname: '/referralsReports',
              state: { data: userSubList, filters: referralReportState }
            })
          }
        }
      } else {
        if (response.data.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.data.message)
          setModal(!modal)
        }
      }
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response?.status === 401) {
        history.push('./sign-in')
        window.location.reload(false)
      } else {
        setModalContent(ex.response?.data?.message || ex.message)
        setModal(!modal)
      }
    });
  };

  const commissiomExportApi = (pageCount) => {
    if (!commissionState.toDate || !commissionState.fromDate) {
      setModalContent("Please enter the correct Date Range.");
      setModal(!modal)
      return
    }
    let locationId = []
    if (commissionState?.byLocation === "ALL") {
      locationId.push("ALL")
    } else {
      locationId.push(commissionState?.byLocation)
    }

    let userId = []
    if (commissionState?.contactName === "ALL") {
      userId.push("ALL")
    } else {
      userId.push(commissionState?.contactName)
    }
    let data = {
      commissionType: commissionState?.commissionType,
      locationId: locationId,
      userId: userId,
      startDate: commissionState?.fromDate,
      endDate: commissionState?.toDate,
      size: 10,
      number: 0,
      sort: "DESC"
    }

    const token = localStorage.getItem("token")
    let url = 'user/commission/get_commission_transaction'
    axioPath.post(url, data, {
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      if (response.data.status === 'SUCCESS') {
        if (response.data.payload) {
          let userSubList = response.data.payload
          if (userSubList.length === 0) {
            setModalContent("No records found")
            setModal(!modal)
          } else {
            history.push({
              pathname: '/commissionReport',
              state: { data: userSubList, filters: commissionState, dataObj: data }
            })
          }
        }
      } else {
        if (response.data.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          if (response.data.message === "No Record found.") {
            history.push({
              pathname: '/commissionReport',
              state: { data: null, filters: commissionState, dataObj: data }
            })
          } else {
            setModalContent(response.data.message)
            setModal(!modal)
          }
        }
      }
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response?.status === 401) {
        history.push('./sign-in')
        window.location.reload(false)
      } else {
        setModalContent(ex.response?.data?.message || ex.message)
        setModal(!modal)
      }
    });
  };

  const classes = useStyles();

  return (
    <>
      {adminRoles &&
        (adminRoles.includes("SUPER_ADMIN") || adminRoles.includes("USER_REPORTS")) ? (
        <Container>
          {loaderVisible && <Spinner />}
          <TableWrapper>
            <Heading>
              <h3>Business Reports</h3>
            </Heading>
            <div className={classes.root}>
              <AppBar position="static" className={classes.AppBar}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="simple tabs example"
                >
                  <Tab label="Subscription" {...a11yProps(0)} />
                  <Tab label="Purchase" {...a11yProps(1)} />
                  <Tab label="Orders" {...a11yProps(2)} />
                  <Tab label="Pickup Orders" {...a11yProps(3)} />
                  <Tab label="Claim" {...a11yProps(4)} />
                  <Tab label="Post" {...a11yProps(5)} className={classes.hiddenTab} />
                  <Tab label="Referrals" {...a11yProps(6)} className={classes.hiddenTab} />
                  <Tab label="Commissions" {...a11yProps(7)} />
                </Tabs>
              </AppBar>

              <TabPanel value={value} index={0}>
                <PanelWrapper>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Subscription</label>
                      <select
                        style={selectStyle}
                        id="subscription"
                        value={subscriptionReportState.subscription}
                        onChange={handleSubReportStateChange}
                      >
                        {subscriptionList.map((data, index) => {
                          return <option value={data}>{data}</option>;
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>User Type</label>
                      <select
                        style={selectStyle}
                        id="userType"
                        value={subscriptionReportState.userType}
                        onChange={handleSubReportStateChange}
                      >
                        <option value="all">All</option>
                        <option value="buying">Buyer</option>
                        <option value="selling">Seller</option>
                        <option value="both">Both</option>
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Month</label>
                      <select
                        style={selectStyle}
                        id="month"
                        value={subscriptionReportState.month}
                        onChange={handleSubReportStateChange}
                      >
                        {monthListWithAll.map((data, index) => {
                          return (
                            <option value={data.value}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Year</label>
                      <select
                        style={selectStyle}
                        id="year"
                        value={subscriptionReportState.year}
                        onChange={handleSubReportStateChange}
                      >
                        {subYears.map((data, index) => {
                          return <option value={data}>{data}</option>;
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>City</label>
                      <select
                        style={selectStyle}
                        id="city"
                        value={subscriptionReportState.city}
                        onChange={handleSubReportStateChange}
                      >
                        <option value="">All</option>
                        {subReportCities.map((data, index) => {
                          return (
                            <option value={data.label}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <button
                    style={buttonStyle}
                    onClick={() => fetchSubReportAPI()}
                  >
                    Generate Report
                  </button>
                </PanelWrapper>
              </TabPanel>

              <TabPanel value={value} index={1}>
                <PanelWrapper>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Purchase</label>
                      <select
                        style={selectStyle}
                        id="purchase"
                        value={purchaseState.purchase}
                        onChange={handlePurchaseStateChange}
                      >
                        <option value="both">All Purchases</option>
                        <option value="orders">Orders</option>
                        <option value="scription">Subscriptions</option>
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Load/Inventories</label>
                      <select
                        style={selectStyle}
                        id="userType"
                        value={purchaseState.userType}
                        onChange={handlePurchaseStateChange}
                      >
                        <option value="all">All</option>
                        <option value="both">Both</option>
                        <option value="buying">Post Need</option>
                        <option value="selling">Post Inventories</option>
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Payment Mode</label>
                      <select
                        style={selectStyle}
                        id="payment"
                        value={purchaseState.payment}
                        onChange={handlePurchaseStateChange}
                      >
                        <option value="All">All</option>
                        <option value="CREDIT_CARD">Credit Card</option>
                        <option value="DEBIT_CARD">Debit Card</option>
                        <option value="BANK_ACCOUNT">Bank Account</option>
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <DateWrapper>
                      <label>From</label>
                      <DatePicker
                        name="fromDatePurchaseReport"
                        placeholderText=""
                        maxDOBirth={purchaseState.toDate}
                        value={purchaseState.fromDate}
                        inputValue={startPurchaseDateValue}
                        callBackFun={(date, value) => {
                          setStartPurchaseDateValue(value)
                          if (moment(date, moment.ISO_8601, true).isValid()) {
                            setPurchaseState((prevState) => ({
                              ...prevState,
                              ["fromDate"]: moment(date).format("YYYY-MM-DD"),
                            }));
                          } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                            setPurchaseState((prevState) => ({
                              ...prevState,
                              ["fromDate"]: null,
                            }));
                          }
                        }}
                      />
                    </DateWrapper>
                  </InnerDiv>
                  <DateRangeInnerDiv>
                    <DateWrapper>
                      <label>To</label>
                      <DatePicker
                        name="toDatePurchaseReport"
                        placeholderText=""
                        minDOBirth={purchaseState.fromDate}
                        value={purchaseState.toDate}
                        inputValue={endPurchaseDateValue}
                        callBackFun={(date, value) => {
                          setEndPurchaseDateValue(value)
                          if (moment(date, moment.ISO_8601, true).isValid()) {
                            setPurchaseState((prevState) => ({
                              ...prevState,
                              ["toDate"]: moment(date).format("YYYY-MM-DD"),
                            }));
                          } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                            setPurchaseState((prevState) => ({
                              ...prevState,
                              ["toDate"]: null,
                            }));
                          }
                        }}
                      />
                    </DateWrapper>
                  </DateRangeInnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>State</label>
                      <select
                        style={selectStyle}
                        id="state"
                        value={purchaseState.state}
                        onChange={handlePurchaseStateChange}
                      >
                        <option value="">All</option>
                        {states.map((data, index) => {
                          return (
                            <option value={data.value}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>City</label>
                      <select
                        style={selectStyle}
                        id="city"
                        value={purchaseState.city}
                        onChange={handlePurchaseStateChange}
                      >
                        <option value="">All</option>
                        {purchaseCities.map((data, index) => {
                          return (
                            <option value={data.label}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <button
                    style={buttonStyle}
                    onClick={() => fetchPurchaseReportApi()}
                  >
                    Generate Report
                  </button>
                </PanelWrapper>
              </TabPanel>

              <TabPanel value={value} index={2}>
                <PanelWrapper>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Order Type</label>
                      <select
                        placeholder="User Type"
                        id="userType"
                        style={selectStyle}
                        value={orderState.userType}
                        onChange={handleOrderStateChange}
                      >
                        <option value="both">Both</option>
                        <option value="buying">Buying</option>
                        <option value="selling">Selling</option>
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Company name</label>
                      <SearchSection>
                        <SearchTypeahead
                          placeholder='Search by Company Name'
                          focusOnShow={false}
                          filterBy="title"
                          title=''
                          pageType="PostInventory"
                          pageName="Dashboard"
                          containerStyle="makeSearch"
                          color="#074269"
                          backgroundColor="#01b3ff"
                          setCompanyNameValue={(data) => {
                            setOrderState(prevState => ({
                              ...prevState,
                              companyName: data
                            }))
                          }}
                        />
                      </SearchSection>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Month</label>
                      <select
                        style={selectStyle}
                        id="month"
                        value={orderState.month}
                        onChange={handleOrderStateChange}
                      >
                        {monthListWithAll.map((data, index) => {
                          return (
                            <option value={data.value}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>

                  <InnerDiv>
                    <SelectWrapper>
                      <label>Year</label>
                      <select
                        style={selectStyle}
                        id="year"
                        value={orderState.year}
                        onChange={handleOrderStateChange}
                      >
                        <option value='all'>All</option>
                        {subYears.map((data, index) => {
                          return <option value={data}>{data}</option>;
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>

                  <InnerDiv>
                    <SelectWrapper>
                      <label>Orders</label>
                      <select
                        style={selectStyle}
                        id="status"
                        value={orderState.status}
                        onChange={handleOrderStateChange}
                      >
                        {orderStatus.map((data, index) => {
                          return <option value={data.value}>{data.label}</option>
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>

                  <InnerDiv>
                    <SelectWrapper>
                      <label>State</label>
                      <select
                        style={selectStyle}
                        id="state"
                        value={orderState.state}
                        onChange={handleOrderStateChange}
                      >
                        <option value="">All</option>
                        {states.map((data, index) => {
                          return (
                            <option value={data.value}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>City</label>
                      <select
                        style={selectStyle}
                        id="city"
                        value={orderState.city}
                        onChange={handleOrderStateChange}
                      >
                        <option value="">All</option>
                        {orderCities.map((data, index) => {
                          return (
                            <option value={data.label}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <button
                    style={buttonStyle}
                    onClick={() => fetchOrderReportApi()}
                  >
                    Generate Report
                  </button>
                </PanelWrapper>
              </TabPanel>

              <TabPanel value={value} index={3}>
                <PanelWrapper>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Company name</label>
                      <SearchSection>
                        <SearchTypeahead
                          placeholder='Search by Company Name'
                          focusOnShow={false}
                          filterBy="title"
                          title=''
                          pageType="PostInventory"
                          pageName="Dashboard"
                          containerStyle="makeSearch"
                          color="#074269"
                          backgroundColor="#01b3ff"
                          setCompanyNameValue={(data) => {
                            setPickupOrderState(prevState => ({
                              ...prevState,
                              companyName: data
                            }))
                          }}
                        />
                      </SearchSection>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <DateWrapper>
                      <label>From</label>
                      <DatePicker
                        name="fromDatePickupOrderReport"
                        placeholderText=""
                        type={'returnNormalDate'}
                        maxDOBirth={pickupOrderState.toDate}
                        value={pickupOrderState.fromDate}
                        inputValue={pickupOrderState.fromDate}
                        callBackFun={(date, value) => {
                          if (moment(date, moment.ISO_8601, true).isValid()) {
                            setPickupOrderState((prevState) => ({
                              ...prevState,
                              ["fromDate"]: moment(date).format("MM/DD/YYYY"),
                            }));
                          } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                            setPickupOrderState((prevState) => ({
                              ...prevState,
                              ["fromDate"]: null,
                            }));
                          }
                        }}
                      />
                    </DateWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <DateWrapper>
                      <label>To</label>
                      <DatePicker
                        name="toDatePickupOrderReport"
                        placeholderText=""
                        type={'returnNormalDate'}
                        minDOBirth={pickupOrderState.fromDate}
                        value={pickupOrderState.toDate}
                        inputValue={pickupOrderState.toDate}
                        callBackFun={(date, value) => {
                          setEndPurchaseDateValue(value)
                          if (moment(date, moment.ISO_8601, true).isValid()) {
                            setPickupOrderState((prevState) => ({
                              ...prevState,
                              ["toDate"]: moment(date).format("MM/DD/YYYY"),
                            }));
                          } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                            setPickupOrderState((prevState) => ({
                              ...prevState,
                              ["toDate"]: null,
                            }));
                          }
                        }}
                      />
                    </DateWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <MultiSelectFieldWrapper>
                      <label>Order Status</label>
                      <MultiSelect
                        name="pickupOrderStatus"
                        returnValue='true'
                        data={pickupOrderStatus}
                        multiSelectVal={pickupOrderState.status}
                        defaultValueArr={pickupOrderState.status}
                        isSearchable={false}
                        onChangeHandler={(data) => {
                          const containsAll = Array.isArray(data) && data[data.length - 1].value === 'ALL'
                          setPickupOrderState(prevState => ({
                            ...prevState,
                            status: containsAll ? [{ value: 'ALL', label: 'All' }] : (data?.filter(data => data.value !== 'ALL') || [{ value: 'ALL', label: 'All' }])
                          }));
                        }}
                      />
                    </MultiSelectFieldWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>State</label>
                      <select
                        style={selectStyle}
                        id="state"
                        value={pickupOrderState.state}
                        onChange={handlePickupOrderStateChange}
                      >
                        <option value="">All</option>
                        {states.map((data, index) => {
                          return (
                            <option value={data.value}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>City</label>
                      <select
                        style={selectStyle}
                        id="city"
                        value={pickupOrderState.city}
                        onChange={handlePickupOrderStateChange}
                      >
                        <option value="">All</option>
                        {orderCities.map((data, index) => {
                          return (
                            <option value={data.label}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <button
                    style={buttonStyle}
                    onClick={() => fetchPickupOrderReportApi()}
                  >
                    Generate Report
                  </button>
                </PanelWrapper>
              </TabPanel>

              <TabPanel value={value} index={4}>
                <PanelWrapper>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Claim</label>
                      <select
                        style={selectStyle}
                        id="claimType"
                        value={claimState.claimType}
                        onChange={handleClaimStateChange}
                      >
                        {claimLists.map((data, index) => {
                          return <option value={data}>{data}</option>;
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Company name</label>
                      <SearchSection>
                        <SearchTypeahead
                          placeholder='Search by Company Name'
                          focusOnShow={false}
                          filterBy="title"
                          title=''
                          pageType="PostInventory"
                          pageName="Dashboard"
                          containerStyle="makeSearch"
                          color="#074269"
                          backgroundColor="#01b3ff"
                          setCompanyNameValue={(data) => {
                            setClaimState(prevState => ({
                              ...prevState,
                              companyName: data
                            }))
                          }}
                        />
                      </SearchSection>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <DateWrapper>
                      <label>From</label>
                      <DatePicker
                        name="fromDateOtherReports"
                        placeholderText=""
                        maxDOBirth={claimState.toDate}
                        value={claimState.fromDate}
                        inputValue={startOtherReportsDateValue}
                        callBackFun={(date, value) => {
                          setStartOtherReportsDateValue(value)
                          if (moment(date, moment.ISO_8601, true).isValid()) {
                            setClaimState((prevState) => ({
                              ...prevState,
                              ["fromDate"]: moment(date).format("YYYY-MM-DD"),
                            }));
                          } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                            setClaimState((prevState) => ({
                              ...prevState,
                              ["fromDate"]: null,
                            }));
                          }
                        }}
                      />
                    </DateWrapper>
                  </InnerDiv>
                  <DateRangeInnerDiv>
                    <DateWrapper>
                      <label>To</label>
                      <DatePicker
                        name="toDateOtherReports"
                        placeholderText=""
                        minDOBirth={claimState.fromDate}
                        value={claimState.toDate}
                        inputValue={endOtherReportsDateValue}
                        callBackFun={(date, value) => {
                          setEndOtherReportsValue(value)
                          if (moment(date, moment.ISO_8601, true).isValid()) {
                            setClaimState((prevState) => ({
                              ...prevState,
                              ["toDate"]: moment(date).format("YYYY-MM-DD"),
                            }));
                          } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                            setClaimState((prevState) => ({
                              ...prevState,
                              ["toDate"]: null,
                            }));
                          }
                        }}
                      />
                    </DateWrapper>
                  </DateRangeInnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>State</label>
                      <select
                        style={selectStyle}
                        id="state"
                        value={claimState.state}
                        onChange={handleClaimStateChange}
                      >
                        <option value="">All</option>
                        {states.map((data, index) => {
                          return (
                            <option value={data.value}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>City</label>
                      <select
                        style={selectStyle}
                        id="city"
                        value={claimState.city}
                        onChange={handleClaimStateChange}
                      >
                        <option value="">All</option>
                        {claimCities.map((data, index) => {
                          return (
                            <option value={data.label}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <button
                    style={buttonStyle}
                    onClick={() => fetchClaimReportApi()}
                  >
                    Generate Report
                  </button>
                </PanelWrapper>
              </TabPanel>

              <TabPanel value={value} index={5}>
                <PanelWrapper className="pb-0">
                  <InnerDiv>
                    <RadioGroup
                      row
                      aria-label="position"
                      value={radioValue}
                      onChange={handleRadioChange}
                      name="position"
                      defaultValue="end"
                    >
                      <FormControlLabel
                        value="AVAILABLE"
                        control={<Radio color="primary" />}
                        label="Open"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="BIDDING_CLOSE"
                        control={<Radio color="primary" />}
                        label="Closed Without Orders"
                        labelPlacement="end"
                      />
                    </RadioGroup>
                  </InnerDiv>
                </PanelWrapper>
                <PanelWrapper>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Show</label>
                      <select
                        id="postType"
                        style={selectStyle}
                        value={loadInventoryState.postType}
                        onChange={handlePostStateChange}
                      >
                        <option value="postLoad">Post Need</option>
                        <option value="postInventory">Post Inventory</option>
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Company name</label>
                      <SearchSection>
                        <SearchTypeahead
                          placeholder='Search by Company Name'
                          focusOnShow={false}
                          filterBy="title"
                          title=''
                          pageType="PostInventory"
                          pageName="Dashboard"
                          containerStyle="makeSearch"
                          color="#074269"
                          backgroundColor="#01b3ff"
                          setCompanyNameValue={(data) => {
                            setLoadInventoryState(prevState => ({
                              ...prevState,
                              companyName: data
                            }))
                          }}
                        />
                      </SearchSection>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <DateWrapper>
                      <label>From</label>
                      <DatePicker
                        name="fromDateOtherReports"
                        placeholderText=""
                        maxDOBirth={claimState.toDate}
                        value={claimState.fromDate}
                        inputValue={startOtherReportsDateValue}
                        callBackFun={(date, value) => {
                          setStartOtherReportsDateValue(value)
                          if (moment(date, moment.ISO_8601, true).isValid()) {
                            setLoadInventoryState((prevState) => ({
                              ...prevState,
                              ["fromDate"]: moment(date).format("YYYY-MM-DD"),
                            }));
                          } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                            setLoadInventoryState((prevState) => ({
                              ...prevState,
                              ["fromDate"]: null,
                            }));
                          }
                        }}
                      />
                    </DateWrapper>
                  </InnerDiv>
                  <DateRangeInnerDiv>
                    <DateWrapper>
                      <label>To</label>
                      <DatePicker
                        name="toDateOtherReports"
                        placeholderText=""
                        minDOBirth={claimState.fromDate}
                        value={claimState.toDate}
                        inputValue={endOtherReportsDateValue}
                        callBackFun={(date, value) => {
                          setEndOtherReportsValue(value)
                          if (moment(date, moment.ISO_8601, true).isValid()) {
                            setLoadInventoryState((prevState) => ({
                              ...prevState,
                              ["toDate"]: moment(date).format("YYYY-MM-DD"),
                            }));
                          } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                            setLoadInventoryState((prevState) => ({
                              ...prevState,
                              ["toDate"]: null,
                            }));
                          }
                        }}
                      />
                    </DateWrapper>
                  </DateRangeInnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>State</label>
                      <select
                        style={selectStyle}
                        id="state"
                        value={loadInventoryState.state}
                        onChange={handlePostStateChange}
                      >
                        <option value="">All</option>
                        {states.map((data, index) => {
                          return (
                            <option value={data.value}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>City</label>
                      <select
                        style={selectStyle}
                        id="city"
                        value={loadInventoryState.city}
                        onChange={handlePostStateChange}
                      >
                        <option value="">All</option>
                        {loadInvCities.map((data, index) => {
                          return (
                            <option value={data.label}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <button
                    style={buttonStyle}
                    onClick={() => fetchLoadInventoryReportApi()}
                  >
                    Generate Report
                  </button>
                </PanelWrapper>
              </TabPanel>

              <TabPanel value={value} index={6}>
                <PanelWrapper>
                  <div>
                    <InnerDiv>
                      <SelectWrapper>
                        <label>Month</label>
                        <select
                          style={selectStyle}
                          id="month"
                          value={referralReportState.month}
                          onChange={handleReferralStateChange}
                        >
                          {monthList.map((data, index) => {
                            return (
                              <option value={data.value}>{data.label}</option>
                            );
                          })}
                        </select>
                      </SelectWrapper>
                    </InnerDiv>
                  </div>
                  <InnerDiv>
                    <SelectWrapper>
                      <label>Year</label>
                      <select
                        style={selectStyle}
                        id="year"
                        value={referralReportState.year}
                        onChange={handleReferralStateChange}
                      >
                        {subYears.map((data, index) => {
                          return <option value={data}>{data}</option>;
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <button
                    style={buttonStyle}
                    onClick={() => fetchReferralsReportApi()}
                  >
                    Generate Report
                  </button>
                </PanelWrapper>
              </TabPanel>

              <TabPanel value={value} index={7}>
                <PanelWrapper>
                  <div>
                    <InnerDiv>
                      <SelectWrapper>
                        <label>Commission Type</label>
                        <select
                          style={selectStyle}
                          id="commissionType"
                          value={commissionState.commissionType}
                          onChange={handleCommissionTypeStateChange}
                        >
                          {commissionTypeArr.map((data, index) => {
                            return (
                              <option value={data.value}>{data.label}</option>
                            );
                          })}
                        </select>
                      </SelectWrapper>
                    </InnerDiv>
                  </div>

                  <InnerDiv>
                    <SelectWrapper>
                      <label>Company Name</label>
                      <select
                        style={selectStyle}
                        id="byLocation"
                        value={commissionState.byLocation}
                        onChange={handleCommissionTypeStateChange}
                      >
                        {commissionLocationResonse && commissionLocationResonse.map((data, index) => {
                          return (
                            <option value={data.value}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>

                  <InnerDiv>
                    <SelectWrapper>
                      <label>Contact Name</label>
                      <select
                        style={selectStyle}
                        id="contactName"
                        value={commissionState.contactName}
                        onChange={handleCommissionTypeStateChange}
                      >
                        {contactResonse && contactResonse.map((data, index) => {
                          return (
                            <option value={data.value}>{data.label}</option>
                          );
                        })}
                      </select>
                    </SelectWrapper>
                  </InnerDiv>
                  <InnerDiv>
                    <DateWrapper>
                      <label>From</label>
                      <DatePicker
                        name="fromDateOtherReports"
                        placeholderText=""
                        maxDOBirth={claimState.toDate}
                        value={claimState.fromDate}
                        inputValue={startOtherReportsDateValue}
                        callBackFun={(date, value) => {
                          setStartOtherReportsDateValue(value)
                          if (moment(date, moment.ISO_8601, true).isValid()) {
                            setCommissionState((prevState) => ({
                              ...prevState,
                              ["fromDate"]: moment(date).format("YYYY-MM-DD"),
                            }));
                          } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                            setCommissionState((prevState) => ({
                              ...prevState,
                              ["fromDate"]: null,
                            }));
                          }
                        }}
                      />
                    </DateWrapper>
                  </InnerDiv>
                  <DateRangeInnerDiv>
                    <DateWrapper>
                      <label>To</label>
                      <DatePicker
                        name="toDateOtherReports"
                        placeholderText=""
                        minDOBirth={claimState.fromDate}
                        value={claimState.toDate}
                        inputValue={endOtherReportsDateValue}
                        callBackFun={(date, value) => {
                          setEndOtherReportsValue(value)
                          if (moment(date, moment.ISO_8601, true).isValid()) {
                            setCommissionState((prevState) => ({
                              ...prevState,
                              ["toDate"]: moment(date).format("YYYY-MM-DD"),
                            }));
                          } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                            setCommissionState((prevState) => ({
                              ...prevState,
                              ["toDate"]: null,
                            }));
                          }
                        }}
                      />
                    </DateWrapper>
                  </DateRangeInnerDiv>

                  <button
                    style={buttonStyle}
                    onClick={() => commissiomExportApi()}
                  >
                    Generate Report
                  </button>
                </PanelWrapper>
              </TabPanel>
            </div>
          </TableWrapper>
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title=''
            content={modalContent}
          />
        </Container>
      ) : (
        <p>You are not authorized to view this page.</p>
      )}
    </>
  );

}

export default Reports

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  hiddenTab: {
    display: 'none',
  },
}));
